import axios from 'axios';
import { apiWrapper } from '../utils/apiWrapper';
import { getConfig } from '../utils/getConfig';

export const createBannerApi = async ({ title, releaseDate, isActive, imageLink, token, dateOnly }) => {
	const config = getConfig(token);
	return await apiWrapper(
		axios.post(
			`${import.meta.env.VITE_APP_API_URL}/banner`,
			{ title, releaseDate, isActive, imageLink, dateOnly },
			config
		)
	);
};

export const deleteBannerApi = async (id, token) => {
	const config = getConfig(token);
	return await apiWrapper(axios.delete(`${import.meta.env.VITE_APP_API_URL}/banner/${id}`, config));
};

export const markAsActiveBannerApi = async (id, status, token) => {
	const config = getConfig(token);
	return await apiWrapper(
		axios.put(`${import.meta.env.VITE_APP_API_URL}/banner/toggleStatus/${id}`, { status }, config)
	);
};

export const editBannerApi = async ({ id, title, releaseDate, isActive, imageLink, token, dateOnly }) => {
	const config = getConfig(token);
	return await apiWrapper(
		axios.put(
			`${import.meta.env.VITE_APP_API_URL}/banner/${id}`,
			{ title, releaseDate, isActive, imageLink, dateOnly },
			config
		)
	);
};

export const bannerApis = {
	createBannerApi,
	deleteBannerApi,
	markAsActiveBannerApi,
	editBannerApi
};
